import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import DemanderRelivraisonDialogContent from '../DemanderRelivraisonDialogContent'; // #2
import DemanderImperatifDialogContent from '../DemanderImperatifDialogContent'; // #3
import DemanderRechercheColisDialogContent from '../DemanderRechercheColisDialogContent'; // #4
import DemanderEnqueteChauffeurDialogContent from '../DemanderEnqueteChauffeurDialogContent'; // #6
import PlainteLivraisonSauvageDialogContent from '../PlainteLivraisonSauvageDialogContent'; // #7
import DemandeDestructionContent from './DemandeDestructionContent';
import DemandeRetourMarchandisesContent from './DemandeRetourMarchandisesContent';
import ReponseSouffranceTransporteurContent from './ReponseSouffranceTransporteurContent';
import DemandeEnlevementContent from './DemandeEnlevementContent';
import ClotureContent from '../../ClotureContent';
import DropZone from 'components/Shared/DropZone';
import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

const styles = {
    formControl: {
        margin: 0,
        width: '100%'
    }
};

/* Liste des réponses possibles */
const resultatLabel = "Indiquer le résultat";
const reponses = [
/* 0 */'Manquant annoncé au départ',
/* 1 */'Le colis est livré',
/* 2 */'Livraison partielle',
/* 3 */'Le colis est en transit / en cours d\'acheminement',
/* 4 */'Le colis est livré mais la livraison est contestée par le client',
/* 5 */'Un colis est détérioré',
/* 6 */'Non livrable / perdu',
/* 7 */'En souffrance'
];


const livreResultatLabel = "Le colis est livré : ";
const livreReponses = [
/* 0 */'Preuve de livraison non signée',
/* 1 */'Preuve de livraison signée',
/* 2 */'Après recherche',
];

const relanceLabel = "Relance courante à sélectionner";
const relances = [
/* 0 */'Demander une livraison au transporteur',
/* 1 */'Demander un impératif au transporteur + suivi',
/* 2 */'Demander une recherche d\'un colis au transporteur',
/* 3 */'Demander une enquête chauffeur',
];
const relances4 = [
/* 0 */'Demander une recherche d\'un colis au transporteur',
/* 1 */'Demander une enquête chauffeur',
/* 2 */'Ouvrir une réclamation chez le transporteur : plainte pour livraison sauvage',
];

const renvoiLabel = "Peut-on renvoyer à nouveau la commande ?";

const localisationLabel = "Où se trouve la marchandise ?";
const localisationReponses = [
/* 0 */'Chez le transporteur',
/* 1 */'Chez le client',
];

const demandeLabel = "Sélectionner l'action requise";
const demandeReponses = [
/* 0 */'Demande de retour marchandise',
/* 1 */'Demande de destruction',
/* 2 */'Pas d\'action requise auprès du transporteur',
];

const traitementLabel = "Quel traitement du/des colis ?";
const traitementReponses = [
/* 0 */'À nous retourner depuis le dépôt transporteur',
/* 1 */'À relivrer (à une autre adresse par le même transporteur)',
/* 2 */'À relivrer par un autre transporteur (marchandises restées à quai chez les expressistes)',
];

class RechercheColisSiteWebDialogContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            resultat: '',
            livreResultat: '',
            relance: '',
            relance4: '',
            renvoi: '',
            numeroBL: '',
            numeroFacturation: '',
            numeroAvoirClient: '',
            localisation: '',
            demande: '',
            traitement: '',
            commentaire: '',
            fichiersIds: [],
            clotureData: null,
            subComponentActionData: null,
            nbColis: 0
        };
    }


    getActionData(newState) {
        const { action } = this.props;

        if (newState.subComponentActionData === 'invalid') {
            return null;
        }

        if (newState.resultat === '') {
            return null;
        }

        if (newState.resultat === 1) {
            if (newState.livreResultat === '') {
                return null;
            }
        }

        if (newState.resultat === 2) {
            if (newState.relance === '') {
                return null;
            }
        }

        if (newState.resultat === 3) {
            if (newState.relance === '') {
                return null;
            }
        }

        if (newState.resultat === 4) {
            if (newState.relance4 === '') {
                return null;
            }
        }

        if (newState.resultat === 5) {
            if (newState.renvoi === '') {
                return null;
            }
            if (newState.localisation === '') {
                return null;
            }
            if (newState.demande === '') {
                return null;
            }
        }

        if (newState.resultat === 6) {
            if (newState.renvoi === '') {
                return null;
            }
            if (newState.demande === '') {
                return null;
            }
        }

        if (newState.resultat === 7) {
            if (newState.traitement === '') {
                return null;
            }
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: resultatLabel,
                position: 0,
                valeurString: reponses[newState.resultat],
                valeurInteger: newState.resultat
            }]
        };

        /* 0 'Manquant annoncé au départ',*/
        if (newState.resultat === 0) {
            if (newState.commentaire !== '') {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Commentaire,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Commentaire',
                    position: actionData.details.length,
                    valeurString: newState.commentaire
                });
            }
        }


        /* 1 'Le colis est livré',*/
        if (newState.resultat === 1) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: livreResultatLabel,
                position: actionData.details.length,
                valeurString: livreReponses[newState.livreResultat],
                valeurInteger: newState.livreResultat
            });
            if (newState.livreResultat === 0) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.VerificationJours,
                    type: ReclamationActionDetailType.Entier,
                    libelle: 'Modification de la date de vérification',
                    position: actionData.details.length,
                    valeurInteger: 2
                });
            }
            if (newState.commentaire !== '') {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Commentaire,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Commentaire',
                    position: actionData.details.length,
                    valeurString: newState.commentaire
                });
            }
        }

        /* 2 Livraison partielle',*/
        if (newState.resultat === 2) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: relanceLabel,
                position: actionData.details.length,
                valeurString: relances[newState.relance],
                valeurInteger: newState.relance
            });
            actionData.details.push({
                code: ReclamationActionDetailCodes.NombreColis,
                type: ReclamationActionDetailType.Entier,
                libelle: "Nombre de colis livré(s)",
                position: actionData.details.length,
                valeurInteger: newState.nbColis
            });

        }

        /* 3 'Le colis est en transit / en cours d\'acheminement',*/
        if (newState.resultat === 3) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: relanceLabel,
                position: actionData.details.length,
                valeurString: relances[newState.relance],
                valeurInteger: newState.relance
            });
        }

        /* 4 'Le colis est livré mais la livraison est contestée par le client',*/
        if (newState.resultat === 4) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: relanceLabel,
                position: actionData.details.length,
                valeurString: relances[newState.relance4],
                valeurInteger: newState.relance4
            });
        }

        /* 5 'Un colis est détérioré',*/
        if (newState.resultat === 5) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Booleen,
                libelle: renvoiLabel,
                position: actionData.details.length,
                valeurBool: newState.renvoi === '1' ? true : false
            });

            if (newState.renvoi === '1') {

                if (newState.numeroAvoirClient !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Avoir,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Avoir client",
                        position: actionData.details.length,
                        valeurString: newState.numeroAvoirClient,
                    });
                }

                if (newState.numeroBL !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.NumeroPiece,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Prépa",
                        position: actionData.details.length,
                        valeurString: newState.numeroBL,
                    });
                }

                if (newState.numeroFacturation !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.NumeroFacture,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Facture transporteur",
                        position: actionData.details.length,
                        valeurString: newState.numeroFacturation,
                    });
                }
            }
            else {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.NumeroFacture,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro de facturation",
                    position: actionData.details.length,
                    valeurString: newState.numeroFacturation,
                });

                actionData.details.push({
                    code: ReclamationActionDetailCodes.Avoir,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro d'avoir client",
                    position: actionData.details.length,
                    valeurString: newState.numeroAvoirClient,
                });
            }

            actionData.details.push({
                code: ReclamationActionDetailCodes.LocalisationMarchandises,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: localisationLabel,
                position: actionData.details.length,
                valeurString: localisationReponses[newState.localisation],
                valeurInteger: newState.localisation
            });

            actionData.details.push({
                code: ReclamationActionDetailCodes.Demande,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: demandeLabel,
                position: actionData.details.length,
                valeurString: demandeReponses[newState.demande],
                valeurInteger: newState.demande
            });

            if (newState.demande === 2) {
                if (newState.commentaire !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Commentaire,
                        type: ReclamationActionDetailType.Texte,
                        libelle: 'Commentaire',
                        position: actionData.details.length,
                        valeurString: newState.commentaire
                    });
                }
            }
        }

        /* 6 'Non livrable / perdu',*/
        if (newState.resultat === 6) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Booleen,
                libelle: renvoiLabel,
                position: actionData.details.length,
                valeurBool: newState.renvoi === '1' ? true : false
            });

            if (newState.renvoi === '1') {

                if (newState.numeroAvoirClient !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Avoir,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Avoir client",
                        position: actionData.details.length,
                        valeurString: newState.numeroAvoirClient,
                    });
                }

                if (newState.numeroBL !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.NumeroPiece,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Prépa",
                        position: actionData.details.length,
                        valeurString: newState.numeroBL,
                    });
                }

                if (newState.numeroFacturation !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.NumeroFacture,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Facture transporteur",
                        position: actionData.details.length,
                        valeurString: newState.numeroFacturation,
                    });
                }
            }
            else {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.NumeroFacture,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro de facturation",
                    position: actionData.details.length,
                    valeurString: newState.numeroFacturation,
                });

                actionData.details.push({
                    code: ReclamationActionDetailCodes.Avoir,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro d'avoir client",
                    position: actionData.details.length,
                    valeurString: newState.numeroAvoirClient,
                });
            }

            actionData.details.push({
                code: ReclamationActionDetailCodes.Demande,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: demandeLabel,
                position: actionData.details.length,
                valeurString: demandeReponses[newState.demande],
                valeurInteger: newState.demande
            });

            if (newState.demande === 2) {
                if (newState.commentaire !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Commentaire,
                        type: ReclamationActionDetailType.Texte,
                        libelle: 'Commentaire',
                        position: actionData.details.length,
                        valeurString: newState.commentaire
                    });
                }
            }
        }

        /* 7 'En souffrance'*/
        if (newState.resultat === 7) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: traitementLabel,
                position: actionData.details.length,
                valeurString: traitementReponses[newState.traitement],
                valeurInteger: newState.traitement
            });

            if (newState.traitement === 0) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.NumeroFacture,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro de facturation",
                    position: actionData.details.length,
                    valeurString: newState.numeroFacturation,
                });

                actionData.details.push({
                    code: ReclamationActionDetailCodes.Avoir,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro d'avoir client",
                    position: actionData.details.length,
                    valeurString: newState.numeroAvoirClient,
                });
            }

            if (newState.traitement === 2) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.VerificationJours,
                    type: ReclamationActionDetailType.Entier,
                    libelle: 'Modification de la date de vérification',
                    position: actionData.details.length,
                    valeurInteger: 15
                });
            }
        }

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        if (newState.subComponentActionData) {
            let subComponentDetails = newState.subComponentActionData.details.map(x => {
                let detail = {
                    ...x,
                    position: x.position + actionData.details.length
                };

                return detail;
            });

            // merge des actionData avec celles du sous composants.
            actionData.details = actionData.details.concat(subComponentDetails);

            if (newState.subComponentActionData.fichiersIds && newState.subComponentActionData.fichiersIds.length > 0) {
                actionData.fichiersIds = newState.subComponentActionData.fichiersIds
            }
        }

        return actionData;
    }

    handleChange = (event) => {
        const { renvoi } = this.state;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value,
        };

        if (event.target.name === 'resultat') {
            newState.clotureData = null;
            newState.subComponentActionData = null;
        }
        if (event.target.name === 'traitement') {
            newState.clotureData = null;
        }

        if (renvoi === '1' && event.target.name === 'numeroBL') {
            newState.clotureData = {
                ...newState.clotureData,
                numeroBL: event.target.value
            };
        }

        if (renvoi === '0') {
            newState.clotureData = {
                ...newState.clotureData,
                numeroBL: ''
            };

            newState.numeroBL = '';
        }

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData, newState.clotureData);
    }

    handeChangeSubComponent = (subComponentActionData) => {
        let newState =
        {
            ...this.state,
        };

        if (subComponentActionData === null) {
            newState.subComponentActionData = 'invalid';
        }
        else {
            newState.subComponentActionData = subComponentActionData;
        }

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData, newState.clotureData);
    }

    handeChangeCloture = (clotureData) => {
        const { renvoi, numeroBL } = this.state;

        let newState =
        {
            ...this.state,
            clotureData: clotureData
        };

        if (renvoi === '1' && !!numeroBL) {
            newState.clotureData = {
                ...newState.clotureData,
                numeroBL: numeroBL
            };
        }
        else {
            newState.clotureData = {
                ...newState.clotureData,
                numeroBL: ''
            };

            newState.numeroBL = '';
        }

        this.setState(newState);

        let actionData = this.getActionData(this.state);

        this.props.onChange(actionData, newState.clotureData);
    }

    /* 0 'Manquant annoncé au départ' */
    render0() {
        const { classes } = this.props;
        const { commentaire } = this.state;

        return (
            <React.Fragment>
                <p>Ce résultat provoque une réaffectation du dossier après-vente au groupe de traitement "Qualité entrepôt"</p>

                <TextField className={classes.input} id="commentaire" name="commentaire" label="Commentaire" type="text" value={commentaire} onChange={this.handleChange} fullWidth multiline />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
            </React.Fragment>
        );
    }

    render1() {
        const { livreResultat, commentaire } = this.state;

        return (
            <React.Fragment>
                <TextField
                    id={"livreResultat"}
                    name={"livreResultat"}
                    label={"Le colis est livré :"}
                    fullWidth

                    select
                    SelectProps={{
                        value: livreResultat,
                        onChange: this.handleChange
                    }}
                >
                    {livreReponses.map((reponse, index) => (
                        <MenuItem key={index} value={index}>
                            {reponse}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    value={commentaire}
                    onChange={this.handleChange}
                    fullWidth
                    multiline
                />

                {livreResultat === 0 && this.renderLivre0()}
                {livreResultat === 1 && this.renderLivre1_2()}
                {livreResultat === 2 && this.renderLivre1_2()}
            </React.Fragment>
        );
    }

    render2() {
        const { classes, action, reclamationId } = this.props;
        const { relance, nbColis } = this.state;

        // TODO

        return (
            <React.Fragment>

                <TextField
                    className={classes.formControl}
                    required
                    id="nbColis"
                    name="nbColis"
                    label="Indiquer le nombre de colis livré(s)"
                    type="number"
                    value={nbColis}
                    onChange={this.handleChange}
                    fullWidth
                    inputProps={{
                        min: 0,
                    }}
                />

                <TextField
                    id={"relance"}
                    name={"relance"}
                    label={relanceLabel}
                    fullWidth

                    select
                    SelectProps={{
                        value: relance,
                        onChange: this.handleChange
                    }}
                >
                    {relances.map((reponse, index) => (
                        <MenuItem key={index} value={index}>
                            {reponse}
                        </MenuItem>
                    ))}
                </TextField>


                {relance === 0 && (
                    <DemanderRelivraisonDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                )}

                {relance === 1 && (
                    <DemanderImperatifDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                )}

                {relance === 2 && (
                    <DemanderRechercheColisDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                )}

                {relance === 3 && (
                    <DemanderEnqueteChauffeurDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                )}

            </React.Fragment>
        );
    }

    render3() {
        const { action, reclamationId } = this.props;
        const { relance } = this.state;

        return (
            <React.Fragment>


                <TextField
                    id={"relance"}
                    name={"relance"}
                    label={relanceLabel}
                    fullWidth

                    select
                    SelectProps={{
                        value: relance,
                        onChange: this.handleChange
                    }}
                >
                    {relances.map((reponse, index) => (
                        <MenuItem key={index} value={index}>
                            {reponse}
                        </MenuItem>
                    ))}
                </TextField>


                {relance === 0 && (
                    <React.Fragment>
                        <DemanderRelivraisonDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

                {relance === 1 && (
                    <React.Fragment>
                        <DemanderImperatifDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

                {relance === 2 && (
                    <React.Fragment>
                        <DemanderRechercheColisDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

                {relance === 3 && (
                    <React.Fragment>
                        <DemanderEnqueteChauffeurDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }

    render4() {
        const { action, reclamationId } = this.props;
        const { relance4 } = this.state;

        return (
            <React.Fragment>


                <TextField
                    id={"relance4"}
                    name={"relance4"}
                    label={relanceLabel}
                    fullWidth

                    select
                    SelectProps={{
                        value: relance4,
                        onChange: this.handleChange
                    }}
                >
                    {relances4.map((reponse, index) => (
                        <MenuItem key={index} value={index}>
                            {reponse}
                        </MenuItem>
                    ))}
                </TextField>


                {relance4 === 0 && (
                    <React.Fragment>
                        <DemanderRechercheColisDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

                {relance4 === 1 && (
                    <React.Fragment>
                        <DemanderEnqueteChauffeurDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

                {relance4 === 2 && (
                    <React.Fragment>
                        <PlainteLivraisonSauvageDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

            </React.Fragment>
        );
    }

    render5() {
        const { classes, reclamationId, action } = this.props;
        const { renvoi, localisation, demande, commentaire } = this.state;

        return (
            <React.Fragment>

                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">{renvoiLabel}</FormLabel>
                    <RadioGroup id="renvoi" name="renvoi" className={classes.group} value={renvoi} onChange={this.handleChange}>
                        <FormControlLabel className={classes.heightLabel} value="1" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="0" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

                {renvoi === '1' && (
                    <React.Fragment>
                        <p>Faire l'avoir au client, générer une nouvelle prépa et facturer le transporteur</p>
                        <TextField className={classes.input} id="numeroAvoirClient" name="numeroAvoirClient" label="Indiquer l'avoir client" type="text" value={this.state.numeroAvoirClient} onChange={this.handleChange} fullWidth />
                        <TextField className={classes.input} id="numeroBL" name="numeroBL" label='Indiquer la prépa' type="text" value={this.state.numeroBL} onChange={this.handleChange} fullWidth />
                        <TextField className={classes.input} id="numeroFacturation" name="numeroFacturation" label='Indiquer la facture transporteur' type="text" value={this.state.numeroFacturation} onChange={this.handleChange} fullWidth />
                    </React.Fragment>
                )}


                {renvoi === '0' && (
                    <React.Fragment>
                        <p>Facturation directe sur le compte du transporteur sans envoi de marchandise ET avoir au client</p>
                        <TextField className={classes.input} id="numeroFacturation" name="numeroFacturation" label='Indiquer le numéro de facturation' type="text" value={this.state.numeroFacturation} onChange={this.handleChange} fullWidth />
                        <TextField className={classes.input} id="numeroAvoirClient" name="numeroAvoirClient" label="Indiquer le numéro d'avoir client" type="text" value={this.state.numeroAvoirClient} onChange={this.handleChange} fullWidth />
                    </React.Fragment>
                )}

                {renvoi !== '' && (

                    <TextField
                        id={"localisation"}
                        name={"localisation"}
                        label={localisationLabel}
                        fullWidth

                        select
                        SelectProps={{
                            value: localisation,
                            onChange: this.handleChange
                        }}
                    >
                        {localisationReponses.map((reponse, index) => (
                            <MenuItem key={index} value={index}>
                                {reponse}
                            </MenuItem>
                        ))}
                    </TextField>
                )}

                {localisation !== '' && (

                    <TextField
                        id={"demande"}
                        name={"demande"}
                        label={demandeLabel}
                        fullWidth

                        select
                        SelectProps={{
                            value: demande,
                            onChange: this.handleChange
                        }}
                    >
                        {demandeReponses.map((reponse, index) => (
                            <MenuItem key={index} value={index}>
                                {reponse}
                            </MenuItem>
                        ))}
                    </TextField>
                )}

                {demande === 0 && (
                    <React.Fragment>

                        {renvoi === '1' && localisation === 0 && (
                            <DemandeRetourMarchandisesContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le ou les colis abimés du(des) récépissé(s) ci-dessous, nous vous facturons la marchandise abimée.\nMerci de nous retourner le colis concerné et de ne surtout pas le livrer au client.\nUn avoir vous sera fait à réception de la marchandise sous réserve d'acceptation par notre service retour.\n"} />
                        )}

                        {renvoi === '1' && localisation === 1 && (
                            <DemandeRetourMarchandisesContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le récépissé ci-dessous, un colis étiqueté au nom de {raisonSociale} a été livré chez\n{adresseLivraison}.\nNous vous facturons la marchandise abimée.\nMerci de procéder à la reprise à votre charge et nous faire le suivi.\nUn avoir vous sera fait à réception de la marchandise sous réserve d'acceptation par notre service retour.\n"} />
                        )}

                        {renvoi === '0' && localisation === 0 && (
                            <DemandeRetourMarchandisesContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le ou les colis abimés du(des) récépissé(s) ci-dessous, nous vous facturons la marchandise abimée.\nMerci de nous retourner le colis concerné et de ne surtout pas le livrer au client.\nUn avoir vous sera fait à réception de la marchandise sous réserve d'acceptation par notre service retour.\n"} />
                        )}

                        {renvoi === '0' && localisation === 1 && (
                            <DemandeRetourMarchandisesContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le récépissé ci-dessous, un colis étiqueté au nom de {raisonSociale} a été livré chez\n{adresseLivraison}.\nNous vous facturons la marchandise abimée.\nMerci de procéder à la reprise à votre charge et nous faire le suivi.\nUn avoir vous sera fait à réception de la marchandise sous réserve d'acceptation par notre service retour.\n"} />
                        )}
                    </React.Fragment>
                )}

                {demande === 1 && (
                    <React.Fragment>

                        {renvoi === '1' && localisation === 0 && (
                            <DemandeDestructionContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le ou les colis du(des) récépissé(s) ci-dessous, nous vous facturons la marchandise abimée.\nMerci de procéder à la mise au rebut et de ne surtout pas le livrer au client\n"} />
                        )}

                        {renvoi === '1' && localisation === 1 && (
                            <DemandeDestructionContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le(s) récépissé(s) ci-dessous un colis étiqueté au nom de [Raison Sociale] a été livré chez ----- .\nNous vous facturons la marchandise abimée. Merci de procéder à la reprise à votre charge et de procéder à la destruction:\n"} />
                        )}

                        {renvoi === '0' && localisation === 0 && (
                            <DemandeDestructionContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le(s) récépissé(s) ci-dessous.\nMerci de procéder à la destruction:\n"} />
                        )}

                        {renvoi === '0' && localisation === 1 && (
                            <DemandeDestructionContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le(s) récépissé(s) ci-dessous un colis étiqueté au nom de [Raison Sociale] a été livré chez ----- .\nNous vous facturons la marchandise abimée.\nMerci de procéder à la reprise à votre charge et de procéder à la destruction:\n"} />
                        )}

                    </React.Fragment>
                )}

                {demande === 2 && (
                    <React.Fragment>

                        {localisation === 0 && (
                            <p>La marchandise non conforme se trouve chez le transporteur mais aucune action n'est requise</p>
                        )}

                        {localisation === 1 && (
                            <p>La marchandise non conforme se trouve chez le client mais aucune action n'est requise</p>
                        )}

                        <TextField className={classes.input} id="commentaire" name="commentaire" label="Commentaire" type="text" value={commentaire} onChange={this.handleChange} fullWidth multiline />

                    </React.Fragment>
                )}

                {demande !== '' && (
                    <React.Fragment>
                        <p>Le dossier après-vente sera clôturé, veuillez spécifiez le motif de résolution et la cause principale</p>
                        <ClotureContent onChange={this.handeChangeCloture} reclamationId={reclamationId} />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }

    render6() {
        const { classes, reclamationId, action } = this.props;
        const { renvoi, demande, commentaire } = this.state;

        return (
            <React.Fragment>

                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">{renvoiLabel}</FormLabel>
                    <RadioGroup id="renvoi" name="renvoi" className={classes.group} value={renvoi} onChange={this.handleChange}>
                        <FormControlLabel className={classes.heightLabel} value="1" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="0" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

                {renvoi === '1' && (
                    <React.Fragment>
                        <p>Faire l'avoir au client, générer une nouvelle prépa et facturer le transporteur</p>
                        <TextField className={classes.input} id="numeroAvoirClient" name="numeroAvoirClient" label="Indiquer l'avoir client" type="text" value={this.state.numeroAvoirClient} onChange={this.handleChange} fullWidth />
                        <TextField className={classes.input} id="numeroBL" name="numeroBL" label='Indiquer la prépa' type="text" value={this.state.numeroBL} onChange={this.handleChange} fullWidth />
                        <TextField className={classes.input} id="numeroFacturation" name="numeroFacturation" label='Indiquer la facture transporteur' type="text" value={this.state.numeroFacturation} onChange={this.handleChange} fullWidth />
                    </React.Fragment>
                )}

                {renvoi === '0' && (
                    <React.Fragment>
                        <p>Facturation directe sur le compte du transporteur sans envoi de marchandise ET avoir au client</p>
                        <TextField className={classes.input} id="numeroFacturation" name="numeroFacturation" label='Indiquer le numéro de facturation' type="text" value={this.state.numeroFacturation} onChange={this.handleChange} fullWidth />
                        <TextField className={classes.input} id="numeroAvoirClient" name="numeroAvoirClient" label="Indiquer le numéro d'avoir client" type="text" value={this.state.numeroAvoirClient} onChange={this.handleChange} fullWidth />
                    </React.Fragment>
                )}

                {renvoi !== '' && (

                    <TextField
                        id={"demande"}
                        name={"demande"}
                        label={demandeLabel}
                        fullWidth

                        select
                        SelectProps={{
                            value: demande,
                            onChange: this.handleChange
                        }}
                    >
                        {demandeReponses.map((reponse, index) => {
                            if (index !== 1)
                                return (
                                    <MenuItem key={index} value={index}>
                                        {reponse}
                                    </MenuItem>
                                );
                            else
                                return null;
                        })}
                    </TextField>

                )}

                {demande === 0 && (
                    <React.Fragment>
                        <DemandeRetourMarchandisesContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} memoDefaut={"Pour le ou les colis perdus du(des) récépissé(s) ci-dessous, nous vous facturons la marchandise.\nMerci de nous retourner le colis concerné et de ne surtout pas le livrer au client.\nUn avoir vous sera fait à réception de la marchandise sous réserve d'acceptation par notre service retour.\n"} />
                    </React.Fragment>
                )}

                {demande === 2 && (
                    <React.Fragment>
                        <p>La marchandise non conforme se trouve chez le transporteur mais aucune action n'est requise</p>
                        <TextField className={classes.input} id="commentaire" name="commentaire" label="Commentaire" type="text" value={commentaire} onChange={this.handleChange} fullWidth multiline />
                    </React.Fragment>
                )}

                {demande !== '' && (
                    <React.Fragment>
                        <p>Le dossier après-vente sera clôturé, veuillez spécifiez le motif de résolution et la cause principale</p>
                        <ClotureContent onChange={this.handeChangeCloture} reclamationId={reclamationId} />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }

    render7() {
        const { classes, reclamationId, action } = this.props;
        const { traitement } = this.state;

        return (
            <React.Fragment>

                <TextField
                    id={"traitement"}
                    name={"traitement"}
                    label={traitementLabel}
                    fullWidth

                    select
                    SelectProps={{
                        value: traitement,
                        onChange: this.handleChange,
                        autoFocus: true
                    }}
                >
                    {traitementReponses.map((reponse, index) => (
                        <MenuItem key={index} value={index}>
                            {reponse}
                        </MenuItem>
                    ))}
                </TextField>

                {(traitement === 0 || traitement === 1) && (
                    <React.Fragment>
                        <ReponseSouffranceTransporteurContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

                {(traitement === 0) && (
                    <React.Fragment>
                        <p>Facturation directe sur le compte du transporteur sans envoi de marchandise ET avoir au client</p>
                        <TextField className={classes.input} id="numeroFacturation" name="numeroFacturation" label='Indiquer le numéro de facturation' type="text" value={this.state.numeroFacturation} onChange={this.handleChange} fullWidth />
                        <TextField className={classes.input} id="numeroAvoirClient" name="numeroAvoirClient" label="Indiquer le numéro d'avoir client" type="text" value={this.state.numeroAvoirClient} onChange={this.handleChange} fullWidth />
                        <p>Le dossier après-vente sera clôturé, veuillez spécifiez le motif de résolution et la cause principale</p>
                        <ClotureContent onChange={this.handeChangeCloture} reclamationId={reclamationId} />
                    </React.Fragment>
                )}

                {(traitement === 2) && (
                    <React.Fragment>
                        <DemandeEnlevementContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }

    renderLivre0() {
        const { action, reclamationId } = this.props;

        return (
            <React.Fragment>
                <p>Initialisation de la date de vérification à J+2 ouvré</p>
                <p>Demander une enquête chauffeur</p>
                <DemanderEnqueteChauffeurDialogContent onChange={this.handeChangeSubComponent} action={action} reclamationId={reclamationId} />
            </React.Fragment>
        );
    }

    renderLivre1_2() {
        const { reclamationId } = this.props;

        return (
            <React.Fragment>
                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                <p>Le dossier après-vente sera clôturé, veuillez spécifiez le motif de résolution et la cause principale</p>
                <ClotureContent onChange={this.handeChangeCloture} reclamationId={reclamationId} />
            </React.Fragment>
        );
    }

    render() {
        const { resultat } = this.state;

        return (
            <DialogContent>

                <Stack spacing={1} mt={1}>


                    <TextField
                        id={"resultat"}
                        name={"resultat"}
                        label={"Indiquer le résultat"}
                        fullWidth

                        select
                        SelectProps={{
                            value: resultat,
                            onChange: this.handleChange,
                            autoFocus: true
                        }}
                    >
                        {reponses.map((reponse, index) => (
                            <MenuItem key={index} value={index}>
                                {reponse}
                            </MenuItem>
                        ))}
                    </TextField>


                    {resultat === 0 && this.render0()}
                    {resultat === 1 && this.render1()}
                    {resultat === 2 && this.render2()}
                    {resultat === 3 && this.render3()}
                    {resultat === 4 && this.render4()}
                    {resultat === 5 && this.render5()}
                    {resultat === 6 && this.render6()}
                    {resultat === 7 && this.render7()}

                </Stack>

            </DialogContent>
        );
    }
}

RechercheColisSiteWebDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(RechercheColisSiteWebDialogContent);